<template>
  <div
    :class="{'display-icon-wrapper': extended}"
  >
    <div
      v-html="getIcon.svg"
      class="display-icon"
      :style="{backgroundColor: getIcon.backgroundColor}"
    />
    <p
      class="display-icon-text"
      v-if="extended"
    >
      {{ getIcon.name }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'DisplayIcon',
    props: {
        id: { type: Number, required: true },
        extended: { type: Boolean, default: false },
    },
    computed: {
        ...mapGetters({
            getAllIcons: 'icons/getAllIcons',
        }),
        getIcon() {
            return this.getAllIcons[this.id] || {};
        },
    },
};
</script>

<style lang="scss" scoped>
.display-icon {
    width: 25px;
    height: 25px;
    padding: 3px;
    display: inline-block;
}
.display-icon-wrapper {
    display: flex;
    align-items: center;
}
.display-icon-text {
    margin-left: 10px;
    display: inline-block;
}
</style>
